import React from 'react';
import {useHash} from '@netx/core-components/hooks/useHash';
import {styled} from '@netx/core-components/Theme';
import {
	VirtualizedListItems,
	type VirtualizedListItemsProps,
} from '@netx/core-components/VirtualizedListItemButton/VirtualizedListItems';
import {appRouter} from '@netx/core-next/instance/router';
import {useSavedCartsProvider} from '../../contexts';
import type {ISavedCart} from '../../schema';
import {
	SavedCartListItem,
	type SavedCartListItemProps,
} from '../SavedCartListItem';

const SavedCartListItemsRoot = styled(VirtualizedListItems, {
	name: 'SavedCartListItems',
})(({theme}) => ({}));

export interface SavedCartListItemsProps
	extends Omit<
		VirtualizedListItemsProps,
		'items' | 'totalItems' | 'renderItem'
	> {
	savedCarts: ISavedCart[];
	slotProps?: {
		listItem: Partial<Omit<SavedCartListItemProps, 'key'>>;
	};
}

export const SavedCartListItemsPrimitive = ({
	savedCarts,
	...props
}: SavedCartListItemsProps) => {
	const hash = useHash();

	return (
		<SavedCartListItemsRoot
			{...props}
			items={savedCarts}
			totalItems={savedCarts.length}
			onItemClick={(item) => {
				appRouter.navigate(`cart-assets/${item.id}`, true);
			}}
			renderItem={(virtualItem, item, props) => (
				<SavedCartListItem
					{...props}
					index={virtualItem.index}
					savedCart={item}
					selected={
						hash.current.match(
							new RegExp(`cart-assets/${item.id}(?=$|[/?#])`),
						) != null
					}
					onClick={() => {
						appRouter.navigate(`cart-assets/${item.id}`, true);
					}}
				/>
			)}
		/>
	);
};

export const SavedCartListItems = (
	props: Omit<SavedCartListItemsProps, 'savedCarts'>,
) => {
	const {savedCarts} = useSavedCartsProvider();
	return <SavedCartListItemsPrimitive {...props} savedCarts={savedCarts} />;
};

export default SavedCartListItems;
